import { Route, Routes as RouterRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";

import routes from "./routes";
import PrimaryNav from "./components/PrimaryNav";
import AuthRoute from "../../components/AuthRoute";
import { useFormik } from "formik";
import { createModuleErrorBoundary } from "../../components/ErrorBoundary";

const Body = props => {
  return (
    <Sentry.ErrorBoundary
      fallback={createModuleErrorBoundary("consignment")}
      beforeCapture={scope => {
        scope.setTag("module", "consignment");
      }}
    >
      <RouterRoutes>
        {routes?.map((item, index) => {
          return (
            <Route
              key={index}
              path={item?.path}
              element={
                <AuthRoute permissions={item.permissions}>
                  <item.element {...props} />
                </AuthRoute>
              }
            />
          );
        })}
      </RouterRoutes>
    </Sentry.ErrorBoundary>
  );
};

const Consignment = props => {
  const formik = useFormik({
    initialValues: {},
  });

  return (
    <>
      <PrimaryNav formik={formik} />
      <Body formik={formik} {...props} />
    </>
  );
};

export default Consignment;
